import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import Authorization from '../../HOC/Authorization';
import { ACCOUNT_MANAGER, PROJECT_MANAGER } from '@nexxt/common/constants';
import {
    CLIENTS,
    USERS,
    WORKSPACE,
    MEDIA_LIBRARY,
    QUESTION_LIBRARY,
    PROJECTS,
    MANAGE_PROFILE,
    MY_ACCOUNTS,
    MANAGE_ACCOUNTS,
    OPTION_PACKS,
    PROJECT,
    PROJECT_SELECTION,
    CHECKOUT,
    PAGE_NOT_FOUND,
    LAUNCH_PROJECT,
    AI_CODING,
    AI_CODING_LEGACY
} from '../../constants/routes';

import Users from '../accounts/manageUser';
import ManageProfile from '../accounts/manageProfile';
import ManageAccount from '../accounts/manageAccount';

import TemporaryComponent from '../admin';

import Clients from '../clients';
import Projects from '../projects';
import MediaLibrary from '../libraries/mediaLibrary';
import QuestonLibrary from '../libraries/questionLibrary';
import { PageNotFound } from '../common/noMatchPage';
import ProjectBuilderError from '../project/ProjectBuilderError';

import NewProject from '../project';
import OptionPackList from '../libraries/optionpack/OptionPackList';
import OptionPack from '../libraries/optionpack';
import ProjectSelection from '../project/ProjectSelection';
import SetupWizard from '../project/SetupWizard';
import Checkout from '../payment/checkout';
import LaunchModal from '../project/LaunchModal';
import QuickTagDirectory from '../quicktag/QuickTagDirectory';
import { TENANT_LEVEL } from '@nexxt/common/types';
import { getTenantLevel } from '@nexxt/common/firebase/auth/userDetails';
import Welcome from '../welcome';

const AccountManager = Authorization([ACCOUNT_MANAGER]);
const ProjectManager = Authorization([PROJECT_MANAGER]);
const Admin = Authorization(['ADMIN']);
const CommonAccess = Authorization([ACCOUNT_MANAGER, PROJECT_MANAGER]);

const WorkspaceRouter = () => (
    <Switch>
        {/** Accounts  */}
        <Route path={MANAGE_PROFILE} component={ManageProfile} />
        <Route path={MANAGE_ACCOUNTS} component={ManageAccount} />
        <Route path={USERS} component={AccountManager(Users)} />

        {/** Clients */}
        {/* <Route exact path={CLIENTS} component={Clients} /> */}

        {/** Admin hidden url */}
        <Route path="/admin/projects" component={Admin(TemporaryComponent)} />

        {/**  Libraries */}
        {/* <Route exact path={MEDIA_LIBRARY} component={MediaLibrary} />
        <Route exact path={QUESTION_LIBRARY} component={QuestonLibrary} />
        <Route exact path={OPTION_PACKS} component={OptionPackList} />
        <Route
            exact
            path={OPTION_PACKS + '/:optionid'}
            component={OptionPack}
        /> */}
        {/* <Route exact path={OPTION_PACKS+"/new"} component={OptionPack} /> */}
        <Route
            exact
            path={[AI_CODING, AI_CODING_LEGACY]}
            component={QuickTagDirectory}
        />
        {/** Projects */}
        <Route exact path={WORKSPACE} component={Welcome} />
        <Route exact path={PROJECT_SELECTION} component={ProjectSelection} />
        {/** Checkout */}
        <Route exact path={CHECKOUT} component={Checkout} />

        <Route exact path={LAUNCH_PROJECT} component={LaunchModal} />
        <Route exact path={PROJECTS} component={Projects} />
        <Route
            path={PROJECT}
            render={() => {
                const tenantLevel = getTenantLevel();
                if (tenantLevel === TENANT_LEVEL.INCA_WIZARD) {
                    return <SetupWizard />;
                } else {
                    return (
                        <ProjectBuilderError>
                            <NewProject />
                        </ProjectBuilderError>
                    );
                }
            }}
        />

        <Route exact path={PAGE_NOT_FOUND} component={PageNotFound} />
        <Redirect to={PAGE_NOT_FOUND} />
    </Switch>
);

export default WorkspaceRouter;
